import { render } from "./proposal-details-check-diy.vue?vue&type=template&id=2b77e37d&scoped=true"
import script from "./proposal-details-check-diy.vue?vue&type=script&lang=js"
export * from "./proposal-details-check-diy.vue?vue&type=script&lang=js"

import "./proposal-details-check-diy.vue?vue&type=style&index=0&id=2b77e37d&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b77e37d"]])

export default __exports__